{
  "title": "Overview",
  "sub": "{{date}}. Here's where first articles stand at {{shop}}.",
  "yourShop": "your shop",
  "newFai": "New FAI",
  "kpi": {
    "open": "Open FAIs",
    "pastDue": "Past due",
    "awaiting": "Awaiting approval",
    "fpy": "First-pass yield, 30 days",
    "avgClose": "Avg time to close"
  },
  "queue": {
    "title": "My queue",
    "assigned_one": "{{count}} assigned to you",
    "assigned_other": "{{count}} assigned to you",
    "empty": "Nothing assigned to you.",
    "pickUp": "Pick one up from Inspections."
  },
  "approval": {
    "title": "Awaiting approval",
    "empty": "No FAIs waiting for sign-off."
  },
  "closed": {
    "title": "Closed per week"
  },
  "cal": {
    "title": "Calibration",
    "all": "All gauges",
    "nothingDue": "Nothing due in the next 14 days.",
    "none": "No gauges added yet.",
    "add": "Add your gauges and calibration dates."
  },
  "activity": {
    "title": "Team activity",
    "empty": "Activity from your team shows up here."
  }
}
